import MemberProfile from '@/services/models/Member/MemberProfile'

/**
 * LoginRsp
 * @export
 * @class LoginRsp
 */
export default class LoginRsp {
  public accessToken: string = ''
  public refreshToken: string = ''
  public memberProfile: MemberProfile = new MemberProfile()

  public constructor(fields?: { accessToken?: string; refreshToken?: string; memberProfile?: MemberProfile }) {
    if (fields) {
      Object.assign(this, fields)
    }
  }
}
